import { appConst } from '@/lib';

export default{
    L:(key: string, ...argus: string[]) => {
        if (key) {
            let source = "";
            let keyArr = key.split('.');
            let resultKey = key;
            if(keyArr.length > 1){
                source = keyArr[0];
                keyArr.shift();
                resultKey = keyArr.join('.');
            }
            if(source != "" && window.basic.localization.localizationList[source]){
                return argus.length > 1? window.basic.localization.localize(resultKey, source, ...argus): window.basic.localization.localize(resultKey, source, argus);
            }else{
                let defaultSource = appConst.localization.defaultLocalizationSourceName;
                return argus.length > 1? window.basic.localization.localize(key, defaultSource, ...argus): window.basic.localization.localize(key, defaultSource, argus);
            }
        }
    }
}